import { apiRequest, graphqlRequest } from './index'

export const getRecords = (data) => {
  return graphqlRequest(`
  {
    getRecords {
      ${ data }
    }
  }
  `)
}


export const uploadAttachment = (_id, category, file, event) => {
  const query = `
    mutation ($file: Upload!){
    uploadAttachment(attachmentInfo: {
      _id: "${ _id }"
      category: "${ category }"
      file: $file
     }
     ${ event ? `event:"${ event }"` : '' }
    ){
      attachments {
        category
        key
        name
        size
      }
    }}
  `
  const operations = JSON.stringify({ query, variables: { file: null } })
  const map = {
    '0': ['variables.file']
  }

  const formData = new FormData()
  formData.append('operations', operations)
  formData.append('map', JSON.stringify(map))
  formData.append('0', file)

  return apiRequest('POST', '/beneficiary-api/graphql/v1', formData, { 'content-type': 'multipart/form-data' })
}

export const deleteAttachment = (_id, fileKeys) => {

  return graphqlRequest(`
    mutation {
    removeAttachment(
        _id: "${ _id }"
        fileKeys: ["${ fileKeys.join('","') }"]
      ) {
        attachments {
          category
          key
          name
          size
          audited
          auditedBy
          auditOk
        }
      }
    }`)
}

export const getRecord = (_id, data) => {
  return graphqlRequest(`{
    getRecord(_id: "${ _id }"){
      ${ data }
    }
  }`)
}
export const createRecord = (simulation) => {
  return graphqlRequest(`
  mutation {
    createRecord(simulation: {
      ${ simulation.singleParent ? 'singleParent: true' : '' }
      ${ simulation.childSupport ? `childSupportAnnualAmount:${ simulation.childSupport }` : '' }
      ${ (simulation.partnerIncome || simulation.partnerIncome === 0) ? `partnerAnnualNetIncome:${ simulation.partnerIncome }` : '' }
    }) {
      _id
      status
    }
  }`)

}

export const deleteRecord = (_id) => {
  return graphqlRequest(`
  mutation {
    deleteRecord(
      _id: "${ _id }"
    )
  }`)
}

export const updateRecordQuery = (id, status, query, data) => {
  return graphqlRequest(`
  mutation {
    updateRecord(record: {
      _id: "${ id }"
      status: "${ status }"
      ${ query ? query : '' }
    }) {
      ${ data }
    }
  }`)
}

export const submitRecord = (_id, consent, data) => {
  return graphqlRequest(`
  mutation {
    submitRecord( _id: "${ _id }" consent: "${ consent }" ){
     ${ data }
    }
  }`)
}
